export const SEARCH = {
  DEBOUNCE: 300
};
